// extracted by mini-css-extract-plugin
module.exports = {"overlapCard":"OverlapCard_overlapCard__ZjLrZ","image":"OverlapCard_image__216M_","overlay":"OverlapCard_overlay__s_4Gv","badge":"OverlapCard_badge__QQrWF"};